// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1cyB6","header":"ReportDetails_header__2xwlp","title":"ReportDetails_title__1SJD7","left":"ReportDetails_left__DvZrQ"};